import Vue from 'vue'
import Vuex from 'vuex'
// import Cookies from 'js-cookie'
Vue.use(Vuex)
import { setToken, getToken} from '@/request/util.js'
import { login,getUserInfo} from '@/request/user.js'
import Config from '@/request/config.js'
import websocket from '@/request/websocket'

//引入websocket,以下参数有默认值 2019-10-17
const ws = new websocket({
  //地址
  url:Config.websocketURL,
  //心跳时间（单位:ms）
  //heartBeat:5000,
  //发送心跳信息（支持json传入）
  //heartMsg:'hello',
  //开启重连
  //reconnect:true,
  //重连间隔时间（单位:ms）
  //reconnectTime:5000,
  //重连次数
  //reconnectTimes:10
})
export default new Vuex.Store({
  state: {
      // aa: aa(),
      token: getToken(),
      expires_in:'',
      logCode:'0',
      userId:'',
      userUuid:'',
      userName:'',
      hasGetInfo: false,
      isPosition:false,
      phonePosition:{
        lat: '22.8653',
        lon: '108.285687',
        address: '南宁中关村'
      },
      agrNodeNameState:true,
      agrNodeInfo:{
        name:'',
        uuid:'',
        coordinate:'',
        is_login:'',
      },
      farmNodeNameState:true,
      farmNodeInfo: {
        name: '',
        uuid: '',
        coordinate: '',
        is_login: '',
        nodeType:''
      },
      websocket:{//websocket
        ws:ws,
        msg:null
      },
      imgURL:Config.imgURL,
      meanIndex:0,
      isBack:false,
      backIndex:'',
  },
 mutations: {
    setExpiresIn(state,expires) {
        state.expires_in = expires
    },
    setToken(state,token) {      
        state.token = token
        setToken(token, state.expires_in)
    },
    setUserId (state, id) {
      state.userId = id
    },
    setUserName (state, name) {
      state.userName = name
    },    
    setHasGetInfo(state, status) {
      state.hasGetInfo = status
    },
    setUserUuid(state,uuid) {
        state.userUuid = uuid
    },
    setAgrNodeNameState(state, data) {
      state.agrNodeNameState = data
    },
    setAgrNodeInfo(state,data){
      state.agrNodeInfo.name = data.name
      state.agrNodeInfo.uuid =   data.uuid
      state.agrNodeInfo.coordinate =   data.coordinate
      state.agrNodeInfo.is_login =   data.is_login
    },
    setFarmNodeNameState(state, data) {
      state.farmNodeNameState = data
    },
    setFarmNodeInfo(state, data) {
      state.farmNodeInfo.name = data.name
      state.farmNodeInfo.uuid = data.uuid
      state.farmNodeInfo.coordinate = data.coordinate
      state.farmNodeInfo.is_login = data.is_login
      state.farmNodeInfo.nodeType = data.nodeType
    },
    setPhonePosition(state,data) {
      state.phonePosition.lat = data.lat
      state.phonePosition.lon = data.lon
      state.phonePosition.address = data.address
    },    
    setIsPosition(state,data){
      state.isPosition = data
    },
    setMeanIndex(state, data) {
      state.meanIndex = data
    },
    setIsBack(state,data) {
      state.isBack = data
    },
    setBackIndex(state,data) {
      state.backIndex = data
    }

    
  },
  actions: {
    // 登录
    handleLogin ({ commit, state }, {userName, password}) {
      let login_name = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          login_name,
          password
        }).then(res => {
          const data = res.data          
          state.logCode = data.code
          commit('setExpiresIn', data.expires_in / 3600 / 24)
          commit('setToken', data.access_token)
          //登陆前没有用户token所以websocket登陆失败，故此处再登陆一次websocket
        //   store.state.websocket.ws.login();
          resolve()
        }).catch(err => {
          reject(err)
        })
        // router.addRoutes([state.getRou])
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('setToken', '')
        //   commit('setAccess', [])
        //   window.localStorage.removeItem('expires_in')
        //   window.localStorage.removeItem('token_type')
        //   resolve()
        // }).catch(err => {
        //   reject(err)
        // })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setAccess', [])
        commit('setToken', '')
        resolve()
      })
    },
    //获取用户信息
    getUserInfo ({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {            
          getUserInfo(state.token).then(res => {
            const data = res.data            
            // commit('setAvator', data.avator)
            commit('setUserName', data.user_name)
            commit('setUserId', data.id)
            commit('setUserUuid', data.uuid)
            commit('setHasGetInfo', true)
            // window.localStorage.setItem('getMenu', JSON.stringify(aa))
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
  }
})